// src/components/TZ/imageRes/ImageResults.jsx
import React, { useState } from 'react';
import { Tabs, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';

import SearchForm from './SearchForm';
import ResultsGrid from '../ext/ResultsGrid';
import WipoResultsGrid from '../WIPO/WipoResultsGrid';
import StickySearchPanel from '../../common/StickySearchPanel';

const ImageResults = () => {
  const { results, loading, error } = useSelector((s) => s.search);
  const { lastImageForReport, forms } = useSelector((s) => s.tz);
  const [localState, setLocalState] = useState({
    previewSrc: null,
    originalPreviewSrc: null,
    croppedBlob: null,
    cropConfig: null,
    fileName: null,
  });

  const previewImage = localState.previewSrc || lastImageForReport;
  const mktuValue = forms?.image?.mktu;
  const formattedMktu = Array.isArray(mktuValue) ? mktuValue.join(', ') : mktuValue;
  const quantityValue = forms?.image?.quantity ?? 20;
  const fileName = localState.fileName;
  const imageQuery = fileName || 'Поиск по изображению';

  const items = [
    {
      key: 'tz',
      label: 'ТЗ',
      children: (
        <ResultsGrid
          items={results.image}
          loading={loading.image}
          error={error.image}
          loadingTip="Поиск ТЗ по изображению…"
          errorTitle="Ошибка ТЗ"
          emptyTitle="ТЗ не найдены"
          requestType="По картинке (ТЗ)"
          searchQuery={imageQuery}
        />
      )
    },
    {
      key: 'requests',
      label: 'Заявки',
      children: (
        <ResultsGrid
          items={results.imageReq}
          loading={loading.imageReq}
          error={error.imageReq}
          loadingTip="Поиск заявок по изображению…"
          errorTitle="Ошибка заявок"
          emptyTitle="Заявок не найдено"
          requestType="По картинке (заявки)"
          searchQuery={imageQuery}
        />
      )
    },
    {
      key: 'wipo',
      label: 'WIPO',
      children: (
        <WipoResultsGrid
          items={results.imageWipo}
          loading={loading.imageWipo}
          error={error.imageWipo}
          loadingTip="Поиск WIPO по изображению…"
          errorTitle="Ошибка WIPO"
          emptyTitle="WIPO не найдено"
          requestType="По картинке (WIPO)"
          searchQuery={imageQuery}
        />
      )
    }
  ];

  const compactContent = (
    <>
      {previewImage ? (
        <img
          src={previewImage}
          alt="Изображение поиска"
          className="sticky-search-panel__thumbnail"
          title="Нажмите чтобы развернуть форму"
        />
      ) : null}

      <div className="sticky-search-panel__compact-body">
        {fileName && (
          <span className="sticky-search-panel__query-text">
            <SearchOutlined style={{ marginRight: 6 }} />
            {fileName}
          </span>
        )}

        <div className="sticky-search-panel__query-meta">
          {(loading.image || loading.imageReq || loading.imageWipo) && (
            <Tag color="processing">Поиск…</Tag>
          )}
          {quantityValue && <Tag color="blue">Кол-во: {quantityValue}</Tag>}
          {formattedMktu && <Tag color="geekblue">МКТУ: {formattedMktu}</Tag>}
        </div>
      </div>
    </>
  );

  return (
    <div style={{ width: '100%', padding: 16 }}>
      <SearchForm setLocalState={setLocalState} />
      <Tabs defaultActiveKey="tz" destroyInactiveTabPane={false} items={items} />

      <StickySearchPanel
        compactContent={compactContent}
        threshold={120}
        offsetTop={12}
        overlayOnly
      />
    </div>
  );
};

export default ImageResults;
